import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material"
import { totalCompleteRent, totalRent } from "../../helpers/productsPrice";


export const PaymentMethod = ({formValues}) => {

    const {paymentMethod, product, rents, paymentMethodRent, paymentMethodOptions} = formValues;
    const services = JSON.parse(product);
    const rentsToObj = JSON.parse(rents)

    return (
        <TableContainer component='div'>
            <Table sx={{ minWidth: 650, width:'100%' }} size='small' aria-label="simple table">
                <TableBody>
                    <TableRow >
                        <TableCell sx={{backgroundColor:'#D2D2D2'}} align='left'>MONT. DESMONT. Y TRANSP.</TableCell>
                        <TableCell align='left'>{paymentMethod}</TableCell>
                        <TableCell sx={{backgroundColor:'#D2D2D2'}} align='right'><b>{totalRent(services).toFixed(2)}€</b></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={{backgroundColor:'#D2D2D2'}} align='left'>ALQUILERES</TableCell>
                        <TableCell align='left'>{paymentMethodRent}</TableCell>
                        <TableCell sx={{backgroundColor:'#D2D2D2'}} align='right'><b>{totalCompleteRent(rentsToObj).toFixed(2)}€</b></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={{backgroundColor:'#D2D2D2'}} align='left'>OPCIONALES</TableCell>
                        <TableCell align='left'>{paymentMethodOptions}</TableCell>
                        <TableCell sx={{backgroundColor:'#D2D2D2'}} align='right'></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}
